import React, { useEffect, useState } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { apiLoadPickupLocationSettings, apiSavePickupLocationSettings } from '../../api/pickupLocationSettingApi'
import { loadPickupLocationSettings } from '../../reducers/pickup-location-settings'
import Heading from '../Heading'
import Loading from '../Loading'
import SaveButton from '../SaveButton'
import SelectPickupLocationsItem from '../SelectPickupLocationsItem'

const PickupLocationsTab = () => {
  const [saving, setSaving] = useState(false);

  const dispatch = useDispatch();
  const loaded = useSelector(state => {
    return state.pickupLocationSettings.loaded;
  });
  useEffect(() => {
    if (!loaded) {
      apiLoadPickupLocationSettings(response => {
        dispatch(loadPickupLocationSettings(response));
      });
    }
  }, [loaded]);
  const locationSettings = useSelector(state => {
    return state.pickupLocationSettings.list;
  });
  const handleSaveChanges = (e) => {
    e.preventDefault();
    setSaving(true);
    apiSavePickupLocationSettings(locationSettings, response => {
      setSaving(false);
    })
  }

  return (
    <div className="dreamfox-tab">
      <Heading text="Pickup Locations" />
      {!loaded && <Loading message="Loading..." />}
      {loaded &&
        <div className="dreamfox-tab__content">
          <h3>Pickup Location Overrides</h3>
          <p>Set a custom lead time for orders picked up at a specific location, on top of the global, category and product settings.</p>
          <p>-- Set blank &gt;&gt; use the global/category/product setting.</p>
          <p>-- Set 0 &gt;&gt; for today's pickup.</p>
          {locationSettings.length === 0 &&
            <p><em>No pickup locations are configured yet. Add locations under WooCommerce &rsaquo; Settings &rsaquo; Shipping &rsaquo; Local pickup, then come back here to set lead times per location.</em></p>
          }
          {locationSettings.length > 0 &&
            <div className="dreamfox-select-categories">
              <div className="dreamfox-select-categories__header">
                <div>Pickup location</div>
                <div>Days</div>
              </div>
              {locationSettings.map(item => {
                  return (<SelectPickupLocationsItem key={item.name} item={item}></SelectPickupLocationsItem>)
                })
              }
            </div>
          }
          <SaveButton saving={saving} onClick={handleSaveChanges} />
        </div>
      }
    </div>
  )
}

export default PickupLocationsTab
